import { ThemeSettings } from 'src/theme/Theme';
//? This is for the table row that handles expand/collapse stylings. E.g.: borderLeft, backgroundColor, etc.
import { TableRow } from '@mui/material';

interface TableRowCustomProps {
  children: React.ReactNode;
  borderLeft?: string;
  backgroundColor?: string;
  activeIf?: boolean; // expanded/active state
  activate_border?: boolean;
  activate_bg?: boolean;
  cursorPointerIf?: boolean; // if true, cursor: pointer on hover
  hoverBgColor?: string; // background color on hover (if not expanded)
  [key: string]: any;
  type?: 'borderless' | 'bordered';
  sx?: any;
}

/**
 * TableRow_Custom is a reusable TableRow for expandable/collapsible tables.
 * - Shows primary.light background when expanded (activeIf=true)
 * - Shows pointer cursor on hover if cursorPointerIf=true
 * - Does NOT change background on hover if expanded
 * - Allows custom border and background logic
 */
export const TableRow_Custom = ({
  children, //
  borderLeft,
  backgroundColor,
  activeIf = false,
  activate_border = true,
  activate_bg = true,
  cursorPointerIf = false,
  hoverBgColor,
  borderLeftColor,
  type = 'bordered',
  sx = {},
  ...props
}: TableRowCustomProps) => {
  const theme = ThemeSettings();
  const defaultSx = {
    borderLeft: activeIf && activate_border && type === 'bordered' ? borderLeft || `4px solid ${borderLeftColor || theme.palette.primary.main}` : 'none',
    backgroundColor: activeIf && activate_bg ? backgroundColor || theme.palette.primary.light : undefined,
    cursor: cursorPointerIf ? 'pointer' : 'default',
    '&:hover': !activeIf && cursorPointerIf ? { backgroundColor: hoverBgColor || theme.palette.action.hover, cursor: 'pointer' } : undefined,
    '& >.MuiTableCell-root': {
      borderBottom: activeIf ? `4px solid ${theme.palette.grey[300]}` : 'unset',
      px: 0,
      mx: 0,
    },
  };

  return (
    <TableRow sx={{ ...defaultSx, ...sx }} {...props}>
      {children}
    </TableRow>
  );
};
